// extracted by mini-css-extract-plugin
module.exports = {"price-section":"Price_price-section__GXxYv","price-section--discount":"Price_price-section--discount__hDvSN"};